/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BatchRecordClickerEntriesDto } from '../../models/batch-record-clicker-entries-dto';
import { BatchRecordResultDto } from '../../models/batch-record-result-dto';

export interface ClickerSessionsControllerBatchRecord$Params {
  id: string;
      body: BatchRecordClickerEntriesDto
}

export function clickerSessionsControllerBatchRecord(http: HttpClient, rootUrl: string, params: ClickerSessionsControllerBatchRecord$Params, context?: HttpContext): Observable<StrictHttpResponse<BatchRecordResultDto>> {
  const rb = new RequestBuilder(rootUrl, clickerSessionsControllerBatchRecord.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BatchRecordResultDto>;
    })
  );
}

clickerSessionsControllerBatchRecord.PATH = '/clicker/sessions/{id}/entries/batch';
